import * as React from "react"

import { cn } from "@ui/lib/utils"

// Abweichung vom Kit-Original: `title` muss aus den HTML-Attributen ausgenommen
// werden. Dort ist title ein string (das Tooltip-Attribut), hier ein ReactNode —
// unter `strict` bricht der Typecheck sonst. Bitte ans Kit zurückmelden.
interface PageHeaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  /** Seitentitel. */
  title: React.ReactNode
  /** Optionale Beschreibung unter dem Titel. */
  description?: React.ReactNode
  /** Optionaler Action-Slot rechts (Buttons o. Ä.). */
  actions?: React.ReactNode
}

/**
 * PageHeader — Layout-Primitive des Frontstage Kits.
 *
 * Titel + optionale Beschreibung links, Action-Slot rechts. Auf schmalen
 * Viewports stapeln sich beide Bereiche. Ausschließlich Theme-Tokens.
 */
export function PageHeader({
  title,
  description,
  actions,
  className,
  ...props
}: PageHeaderProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-4 pb-6 sm:flex-row sm:items-center sm:justify-between",
        className,
      )}
      {...props}
    >
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">
          {title}
        </h1>
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  )
}
